import { buildTenantPath, getCurrentTenantId } from "./tenantPath";

const STORAGE_KEY = "app_breadcrumb_trail";

export const readBreadcrumbTrail = () => {
  if (typeof window === "undefined") return [];
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const writeBreadcrumbTrail = (trail) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trail || []));
  } catch {
    // ignore
  }
};

export const getBreadcrumbBackPath = (fallback) => {
  const trail = readBreadcrumbTrail();
  const basePath = trail.length > 1 ? trail[trail.length - 2] : fallback;
  
  // P0 TENANT ISOLATION: Use centralized tenant path builder
  // Preserves tenant_id from current URL when navigating back
  return buildTenantPath(basePath, getCurrentTenantId());
};